import type { ReactNode } from "react";

interface GuidePageTemplateProps {
  children: ReactNode;
}

export const GuidePageTemplate = ({ children }: GuidePageTemplateProps) => (
  <div className="guide-page-template" data-guide-template="standard">
    {children}
  </div>
);
